import jwtAuthAxios from "./auth/jwtAuth";

const userServices = {};

userServices.getUsers = async (params) => {
    const {data} = await jwtAuthAxios.get(`/users${ params ?? ""}`);
    return data;
};

userServices.getPreparerUsers = async (_params) => {
    const {data} = await jwtAuthAxios.get(`/users/get_preparer_users`);
    if (!Array.isArray(data) || !data.every(user => user.id && user.full_name)) {
        throw new Error("Invalid data format: Expected an array of users with id and full_name.");
    }
    return data;
};

userServices.getUser = async (id, params) => {
    const {data} = await jwtAuthAxios.get(`/users/${id}${ params ?? ""}`);
    return data;
};

userServices.getEditOptions = async () => {
    const {data} = await jwtAuthAxios.get(`/users/edit_options`);
    return data;
};

userServices.createUser = async (body) => {
    const {data} = await jwtAuthAxios.post(`/users?include=companies,profiles`, body);
    return data;
};

userServices.saveUser = async (id, params, body) => {
    const {data} = await jwtAuthAxios.put(`/users/${id}${params ?? ""}`, body);
    return data;
}

userServices.toggleUserActivation = async (id, params = null) => {
    const {data} = await jwtAuthAxios.post(`/users/${id}/toggle_activation${params ?? ""}`);
    return data;
};

// userServices.saveRecipients = async (id, params) => {
//     const {data} = await jwtAuthAxios.post(`/customers/${id}/recipients`, params);
//     return data;
// };

userServices.setCurrentCompany = async (id) => {
    const {data} = await jwtAuthAxios.post(`/users/current_company`, { company_id: id });
    return data;
};

userServices.assignCompany = async (id, companyId, params = null) => {
    const {data} = await jwtAuthAxios.post(`/users/${id}/assign_company${params ?? ""}`, { company_id: companyId });
    return data;
};

userServices.unassignCompany = async (id, companyId, params = null) => {
    const {data} = await jwtAuthAxios.delete(`/users/${id}/unassign_company${params ?? ""}`, { data: { company_id: companyId } });
    return data;
};

export default userServices;
